<script>

    import VcPaginacao from '@/components/Form/Paginacao'
    import Vue from 'vue'

    export default {
        components: {
            VcPaginacao
        },
        data() {
            return {
                data: {},
                termo: '',
                pagination: {},
                filtro: null,
                order: 'ASC',
                campo: 'nomerazao_social',
                porPagina: {label: '25', value: '25'},
                tipo: {PROP: true},
            }
        },

        watch: {
            porPagina() {
                this.navigate(1);
            },

            filtro() {
                this.navigate(1);
            },
            "tipo.PROP"(value) {
                if (value) {
                    this.$set(this.tipo, 'REM', false)
                }
                this.navigate(1);
            },
            "tipo.REM"(value) {
                if (value) {
                    this.$set(this.tipo, 'PROP', false)
                }
                this.navigate(1);
            }
        },

        computed: {
            gerente() {
                return this.$store.state.Auth.user != null && this.$store.state.Auth.user.permissao_empresa != null && (parseInt(this.$store.state.Auth.user.permissao_empresa.gerente) || parseInt(this.$store.state.Auth.user.permissao_empresa.master))
            },
        },

        methods: {
            navigate(pagina) {
                const self = this
                
                let tipo = !self.tipo.PROP && !self.tipo.REM ? 'TODOS' : (self.tipo.PROP ? 'PROP' : 'REM');
                window.swal({
                    title: "Buscando pessoas",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        self.$http.post('api/pessoas/listagem?page=' + pagina, {
                            termo: self.termo,
                            campo: self.campo,
                            ordem: self.order,
                            porPg: self.porPagina.value,
                            tipo: tipo,
                        }).then((response) => {
                            self.data = response.data.data;
                            self.pagination = response.data;
                            window.swal.close()
                        });
                    }
                });
            },
            destroy(id) {
                this.$http.post('api/pessoas/destroy/' + id).then((response) => {
                    if (!response.data) {
                        window.swal("Atenção", "Não foi possível eliminar a pessoa, existe um vínculo com analise.", "warning");
                        return false;
                    }
                    window.swal("Sucesso", "Pessoa eliminada com sucesso.", "success").then(() => {
                        this.navigate(1)
                    });
                });

            },
            ordenar(campo) {
                this.$set(this, 'campo', campo);
                if (this.order === 'ASC') {
                    this.order = 'DESC';
                } else {
                    this.order = 'ASC';
                }
                this.navigate(1);
            },
            alterar(model) {
                this.$router.push({name: 'pessoas.editar', params: {id: model.id}});
            },
        },
        mounted() {
            this.navigate(1)
            this.$store.dispatch('setTitle', 'Pessoas')
        }
    }

</script>

<template>
    <div class="margin-top-10">

        <router-link v-if="parseInt(this.$store.state.Auth.user.permissao_empresa.pessoa_manter)" :to="{name: 'pessoas.adicionar'}" class="btn btn-success">Adicionar</router-link>
        <br/>
        <br/>

        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-sm-2">
                        <label>Registros por página </label>
                        <v-select v-model="porPagina" :options="[
                            {label: '10', value: '10'},
                            {label: '25', value: '25'},
                            {label: '50', value: '50'},
                            {label: '100', value: '100'},
                        ]"></v-select>
                    </div>

                    <div class="col-sm-6"><br>
                        <div class="form-group">
                            &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
                            <label class="switch switch-success"><input type="checkbox"
                                                                        v-model="tipo.PROP"><span></span></label>&nbsp;Proprietários
                            / Arrendatários &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;
                            <label class="switch switch-success"><input type="checkbox"
                                                                        v-model="tipo.REM"><span></span></label>&nbsp;Remetentes
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label for="">&nbsp;</label>
                            <input type="text" v-model="termo" class="form-control" placeholder="Pesquisar" @keyup.enter="navigate(1)">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-hover table-striped">
                            <thead>
                            <tr role="row">
                                <th @click="ordenar('nomerazao_social')" style="width: 35%;">Nome / Razão Social</th>
                                <th style="width: 20%;">Tipo</th>
                                <th @click="ordenar('cpfcnpj')" style="width: 18%;">CPF / CNPJ</th>
                                <th @click="ordenar('fones')" style="width: 18%;">Telefone(s)</th>
                                <th class="text-center" colspan="3" style="width: 9%;"> Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr role="row" class="even" v-for="model in data">
                                <td class="text-capitalize" v-if=" model.nome != null">{{model.nome }}</td>
                                <td class="text-capitalize" v-else>{{model.razao_social}}<br/>{{model.fantasia }}
                                </td>
                                <td>
                                    <span class="display-block" v-if="model.fornecedor == '1'">Remetente {{ model.tecnico_agricola == '1' ? ' / ' : ''}}</span>
                                    <span class="display-block" v-if="model.tecnico_agricola == '1'">Proprietário / Arrendatário</span>
                                </td>
                                <td v-if="model.cpf != null || model.cnpj != null">{{ model.cpf != null ? model.cpf : model.cnpj }}</td>
                                <td v-else>Não informado</td>
                                <td>{{model.fone}}<br/>{{model.fone2}}</td>
                                <td v-if="gerente || parseInt(model.fornecedor)" width="3%" class="text-center">
                                    <button class="btn btn-xs btn-success" @click="alterar(model)" title="Alterar">
                                        <i class="fa fa-pen"></i>
                                    </button>
                                </td>
                                <td v-if="gerente || parseInt(model.fornecedor)" width="3%" class="text-center">
                                    <button class="btn btn-xs btn-danger" @click="destroy(model.id)" title="Excluir">
                                        <i class="fa fa-times"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <vc-paginacao :source="pagination" @navigate="navigate"></vc-paginacao>
            </div>
        </div>
    </div>

</template>

<style scoped>

    table th {
        font-size: 15px !important;
    }

    table td {
        font-size: 13px !important;
    }

    table.dataTable thead th, table.dataTable thead td {
        padding: 10px 18px;
        border-bottom: 1px solid #111
    }

    @media screen and (max-width: 584px) {
        table th:nth-child(2) {
            display: none;
        }

        table td:nth-child(2) {
            display: none;
        }
    }

    @media screen and (max-width: 445px) {
        table th:nth-child(3) {
            display: none;
        }

        table td:nth-child(3) {
            display: none;
        }
    }

</style>
